import { FormControlLabel, RadioGroup, Radio, Collapse } from '@mui/material';
import React from 'react';

export enum NotificationState {
  NotNotified = 0,
  Notify = 1,
  AlreadyNotified = 3,
}

interface INotificationStateRadioGroup {
  label: string;
  labelPlacement?: 'start' | 'end';
  disabled?: boolean;
  hidden?: boolean;
  onChange: (state: NotificationState) => void;
  notificationFieldValue?: boolean | null;
  defaultValue?: NotificationState;
}
function NotificationStateRadioGroup(
  {
    label,
    labelPlacement = 'start',
    disabled = false,
    hidden = false,
    onChange,
    notificationFieldValue = false,
    defaultValue = NotificationState.NotNotified,
  }: INotificationStateRadioGroup,
) {
  const [notificationState, setNotificationState] = React.useState<NotificationState>(defaultValue);

  React.useEffect(() => {
    if (notificationFieldValue) {
      setNotificationState(NotificationState.AlreadyNotified);
      onChange(NotificationState.AlreadyNotified);
    }
  }, []);
  const handleFaaNotification = (state : NotificationState) => {
    if (notificationState === NotificationState.AlreadyNotified) {
      return;
    }
    setNotificationState(state);
    onChange(state);
  };
  return (
    <Collapse in={!hidden}>
      <FormControlLabel
        disabled={disabled}
        sx={{ mr: 2 }}
        control={(
          <RadioGroup
            row
            value={notificationState}
            onChange={(event) => {
              const { value } = event.target;
              handleFaaNotification(Number(value));
            }}
          >
            <FormControlLabel
              value={NotificationState.Notify}
              control={<Radio />}
              label="Yes"
              labelPlacement="start"
            />
            <FormControlLabel
              value={NotificationState.NotNotified}
              control={<Radio />}
              label="No"
              labelPlacement="start"
            />
          </RadioGroup>
        )}
        label={label}
        labelPlacement={labelPlacement}
      />
    </Collapse>
  );
}

export default NotificationStateRadioGroup;
